import { useSessionStorage } from "usehooks-ts"

export function useTableSearch(tableId: string, defaultSearchBy = "variant") {
  const [searchText, setSearchText] = useSessionStorage(tableId + "product-table-search-text", "")
  const [searchBy, setSearchBy] = useSessionStorage(
    tableId + "-product-table-search-field",
    defaultSearchBy,
  )

  const effectiveSearchText =
    searchText && searchBy !== "all" ? `${searchBy}:${searchText}` : searchText

  return { searchText, setSearchText, searchBy, setSearchBy, effectiveSearchText }
}
